import React from "react"
import { LayoutContainer, GridContainer, Overlay } from "./grid.style"
import styled from "styled-components"
import withAnimation from "../../design-system/util/withAnimation"

const Grid = ({
  children,
  overlayStyle,
  addMargin = true,
  className,
  ...rest
}) => {
  return (
    <LayoutContainer
      className={`layout-container ${className}`}
      addMargin={addMargin}
      {...rest}
    >
      <GridContainer className="grid-container">{children}</GridContainer>
      <Overlay className="overlay" overlayStyle={overlayStyle} />
    </LayoutContainer>
  )
}

Grid.Animated = withAnimation(Grid)

//Allows it to be targeted by Styled CSS later
export default styled(Grid)``
export { LayoutContainer, GridContainer, Overlay }
